import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    add_additional_price_container: {
        display: 'flex',
        flexGrow: 1,
        padding: "10px",
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
    },
    form_container: {
        backgroundColor: theme.palette.common.white,
        boxSizing: 'border-box',
        width: '100%',
        borderRadius: '4px',
        height: 'fit-content',
        padding: "24px 16px",
        display: 'grid',
        gridTemplateColumns: "repeat(auto-fit, minmax(400px, 1fr));",
        gridColumnGap: "16px",
        rowGap: '16px'
    },
    save_btn: {
        height: 'fit-content',
        gridColumn: 2,
        justifySelf: 'flex-end'
    },
    // comment: {
    //     gridColumnEnd: 3,
    //     gridColumnStart: 1
    // },

}));

export {useStyles}